<div class="bcard projectname" *ngIf="selectedSentItem">
  <div class="info">
    <h4><span>Project Name:</span> {{selectedSentItem?.projectName}}</h4>
    <h4><span>Email Subject:</span> {{selectedSentItem?.subject}}</h4>
    <h4><span>Expiry Date:</span> {{ selectedSentItem?.expiryDate | date: "MM/dd/yyyy"}}
      <span *ngIf="selectedSentItem?.projectExpiry">
        <button class="extdbtn" mat-stroked-button color="primary" matTooltipClass="tooltip"
          (click)="EntendProject(extendProject)" matTooltip="Extend expire date">Extend</button>
      </span>
    </h4>
    <!-- <button *ngIf="ViewtoFinishButton" mat-stroked-button color="primary" matTooltipClass="tooltip"
      (click)="ViewtoFinish()" matTooltip="Mark as Completed">Mark as Completed</button> -->
    <button mat-stroked-button color="primary" matTooltipClass="tooltip"
      (click)="GetGroupList(selectedSentItem.projectID,signature)" matTooltip="Add Participant">Add Participant</button>
  </div>
</div>

  <div class="outerExpansion" *ngFor="let g of participantList; let i = index">
              <mat-accordion class="contacts">
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header  >
                    <mat-panel-title>
                      {{ g.groupName }} — Signers
                      <span class="group-count">
                        {{ getSignedCount(g) }}/{{ g.getProjectGroupRelationParticipantMappingModelList.length }} Signed
                      </span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <ng-container *ngFor="let p of g.getProjectGroupRelationParticipantMappingModelList">
                  
                    <div  class="participant-card"
                      [ngClass]="[getStatusClass(p), !p.participantName?.trim() ? 'add-participant' : '']">
                    
                   
                    <div class="card-left">
                     
                      <div class="info">
                        <h4>

                          {{ p.participantName ? (p.participantName | titlecase) : 'Add Signer' }}

                           <span class="status-chip" [ngClass]="getStatusClass(p)">
                          {{ getStatusLabel(p) }}
                        </span>
                        
                        <small class="date" *ngIf="p.updatedOn">
                          {{ p.updatedOn+'Z' | date:'MMM d, y h:mm a' }}
                        </small>

                        </h4>

                        <!-- <p>{{ p.contactEmail || p.participantEmail }}</p> -->

                        <div class="emails">

                          <div class="currentEmail" *ngIf="!p.enableEmailEdit">
                            <span *ngIf="p.participantEmail!='' && p.contactEmail!=''&& p.participantEmail!=undefined && p.contactEmail!=undefined && p.participantEmail!=null && p.contactEmail!=null">
                              {{p.contactEmail}}
                            </span>
                            <span *ngIf="p.participantEmail=='' || p.participantEmail==undefined ||  p.participantEmail==null ">
                              {{p.contactEmail}}
                            </span>
                            <span *ngIf="p.contactEmail=='' || p.contactEmail==undefined ||  p.contactEmail==null ">
                              {{p.participantEmail}}
                            </span>
                           
                           
                            <span *ngIf="!p.participantName?.trim()" class="assignRole"  >Click to assign someone to this role</span>
                            <button *ngIf="p.participantName?.trim()" class="addEmail" (click)="(editEmail(p,true))" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                          
                            </div>
                          <div class="updateEmail currentEmail" *ngIf="p.enableEmailEdit">                  
                            <input  type="text" placeholder="Add Email" ([ngModel])="updatedParticpantEmail" (blur)="EditParticipantEmail(p,$event)">
                            <button class="addEmail" (click)="(editEmail(p,false))" ><i class="fa fa-check" aria-hidden="true"></i></button>
                          </div>

                            <div class="relationname">{{p.relationName}} </div>
                        
                        </div> 

                        
                        <div class="relationDate">
                          <button class="addEmail m-0" *ngIf="!p.participantName?.trim()" (click)="(editEmail(p,true))" ><i class="fa fa-user-plus" aria-hidden="true"></i></button>
                        

                        
                        </div>
                      </div>
                    </div>

                  
                    <div class="docaction">


          

                      <a  matTooltip="Show Signing Page"
                        *ngIf="g.groupName!=='Send Final Copy'" [href]="p.signingToken" target="_blank">
                          <i class="fa fa-pencil" aria-hidden="true"></i> Sign Now
                      </a>

                      <a  matTooltip="Send Reminder"
                              *ngIf="!p.hasCompleted && g.groupName!=='Send Final Copy' && g.groupName!=='View Only'"
                              (click)="ResendEmail(p)">
                        <!-- <mat-icon>notifications_active</mat-icon> -->
                          <i class="fa fa-bell-o" aria-hidden="true"></i>  Reminder
                    </a>
                      <a  matTooltip="Reopen Signing Link"
                              *ngIf="p.hasCompleted && g.groupName!=='Send Final Copy' && g.groupName!=='View Only'"
                              (click)="ReopenSignatureLink(p)">
                      <i class="fa fa-link" aria-hidden="true"></i> Reopen

                        
                  </a>
                      <!-- <a mat-icon-button matTooltip="Delete Participant"
                              (click)="deleteParticipant(p)">
                        <mat-icon>delete_outline</mat-icon>
                </a> -->
                    </div>
                  </div>
                  </ng-container>
                
                </mat-expansion-panel>
              </mat-accordion>
            </div>

<!-- <div class="" *ngFor="let g of participantList; let i = index">
  <mat-accordion class="contacts">
    <mat-expansion-panel [expanded]=true (click)="togglePanels(i)">
      <mat-expansion-panel-header>
        <mat-panel-title>

          {{g.groupName}}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div *ngFor="let p of g.getProjectGroupRelationParticipantMappingModelList; let in = index" class="bcard">

        <div class="picinfo">
          <div class="userpic" *ngIf="p.participantImageURL ">
            <img [src]="p.participantImageURL" alt="" />
          </div>
          <div class="userpic" *ngIf="!p.participantImageURL">
            <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
            <span class="shortName" *ngIf="p.contactID==0">{{getShortName(p.contactEmail)}}</span>
            <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
          </div>

          <div class="info">
            <h4>{{p.participantName|titlecase}} <mat-icon matTooltip="Approver"
                *ngIf="p.isApprover==true">check_circle_outline</mat-icon></h4>
            <div class="emails">

              <div class="currentEmail" *ngIf="!p.enableEmailEdit">
                <span
                  *ngIf="p.participantEmail!='' && p.contactEmail!=''&& p.participantEmail!=undefined && p.contactEmail!=undefined && p.participantEmail!=null && p.contactEmail!=null">
                  {{p.contactEmail}}
                </span>
                <span *ngIf="p.participantEmail=='' || p.participantEmail==undefined ||  p.participantEmail==null ">
                  {{p.contactEmail}}
                </span>
                <span *ngIf="p.contactEmail=='' || p.contactEmail==undefined ||  p.contactEmail==null ">
                  {{p.participantEmail}}
                </span>
                <button mat-icon-button color="primary"
                  (click)="(editEmail(p,true))"><mat-icon>create</mat-icon></button>
              </div>


              <div class="updateEmail currentEmail" *ngIf="p.enableEmailEdit">
                <input type="text" placeholder="Add Email" ([ngModel])="updatedParticpantEmail"
                  (blur)="EditParticipantEmail(p,$event)">
                <button mat-icon-button color="primary"
                  (click)="(editEmail(p,false))"><mat-icon>check</mat-icon></button>
              </div>

            </div>
          </div>

        </div>


        <div class="chipsAndReminder">


          
        <div class="chips">
          <mat-chip-list aria-label="">
            <div class="Colrd"
            [ngStyle]="{'background-color': p.colourCode }">
             <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
             <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
             <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
             <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
             <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
             <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
            </div>
            <mat-chip>{{p.relationName}} </mat-chip>
          </mat-chip-list>
        </div>

     
        <div class="sendReminder">
          <a mat-icon-button matTooltip="Show Signing Page" *ngIf="g.groupName!=='Send Final Copy'"
            matTooltipShowDelay="1500" matTooltipClass="tooltip" href="{{p.signingToken}}"
            target="_blank"><mat-icon>border_color</mat-icon></a>
          <button *ngIf="g.groupName!=='Send Final Copy' && g.groupName!=='View Only'" mat-icon-button
            matTooltip="Send Reminder" matTooltipShowDelay="1500" matTooltipClass="tooltip" (click)="ResendEmail(p)"
            color="basic"><mat-icon>notifications_active</mat-icon> </button>
          <button
            *ngIf="p.hasCompleted==true && p.hasCompleted!=null && g.groupName!=='Send Final Copy' && g.groupName!=='View Only'"
            mat-icon-button matTooltip="Reopen Signing Link" matTooltipShowDelay="1500" matTooltipClass="tooltip"
            (click)="ReopenSignatureLink(p)" color="basic"><mat-icon>lock_open</mat-icon> </button>
        </div>

        </div>


        <div class="allStatus">

          <div>
            

          <ng-container >
            <div class="proStatus"
              *ngIf="p.isEmailSent==true && p.hasCompleted==null  && p.hasViewed==null">
              <div class="nameIcon">
                <mat-icon>forward_to_inbox</mat-icon> Sent
              </div>             
            </div>
            <div class="proStatus"
              *ngIf="p.hasCompleted==null&& p.hasViewed==true && p.isEmailSent==true">
              <div class="nameIcon">
                <mat-icon>check_circle_outline</mat-icon>Viewed
              </div>              
            </div>
            <div class="proStatus"
              *ngIf="p.isEmailSent==false && p.hasCompleted==null  && p.hasViewed==null">
              <div class="nameIcon">
                <mat-icon>mail_outline</mat-icon> Not Sent
              </div>
            </div>
            
            <div class="proStatus"
              *ngIf="p.hasCompleted==true && p.hasCompleted!=null && p.hasViewed==true && p.isEmailSent==true && p.rejectionMessage==null && p.isApprover==false">
              <div class="nameIcon">
                <mat-icon>check_circle_outline</mat-icon>Signed
              </div>             
            </div>

            <div class="proStatus"
              *ngIf="p.hasCompleted==true && p.hasCompleted!=null && p.hasViewed==true && p.isEmailSent==true && p.rejectionMessage!=null">
              <div class="nameIcon">
                <mat-icon>thumb_down_off_alt</mat-icon>Declined
              </div>             
            </div>

            <div class="proStatus" *ngIf="p.hasCompleted==true && p.isApprover==true">                    
               <div class="nameIcon">
                 <mat-icon>check_box</mat-icon>Approved
             </div>             
             </div>      

          </ng-container>

        
          </div>

          <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
            {{p.updatedOn+'Z' | date:'h:mm a'}}
          </span>



          
          
        </div>
        
        <span class="rejectMessage" *ngIf="p.rejectionMessage!=null">Rejection Message : {{p.rejectionMessage}}</span>
      </div>


    </mat-expansion-panel>
  </mat-accordion>
</div> -->

<div class="notselected" *ngIf="participantList == '' || participantList == undefined">
  <mat-icon>speaker_notes_off</mat-icon>
  <p>Select a sent item to view its details</p>
</div>
<ng-template #signature>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>group_add</mat-icon></span>
    Add emails of participants
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="signaturePanel">
      <div class="esign">
        <div class="panel">

          <div class="groupHolder" *ngFor="let p1 of projectGroups">

            <div id="{{p1.groupName}}" class="example-list">

              <div class="groupheading">
                <h2 *ngIf="p1.groupType ==1">
                  <mat-icon>create</mat-icon>{{p1.groupName}}
                </h2>

                <h2 *ngIf="p1.groupType !=1">
                  <mat-icon>description</mat-icon>{{p1.groupName}}
                </h2>

              </div>

              <div *ngIf="p1.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
                <p class="nocontent">No relationship added</p>
              </div>

              <div *ngFor="let p of p1.projGrpRelationParticipantList" class="moveblock example-box">

                <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                </div>

                <div class="userInfo">
                  <div class="chipss">
                    <mat-chip-list>
                      <mat-chip> {{p.relationName}} </mat-chip>
                    </mat-chip-list>
                  </div>


                  <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                    <div class="userpic" *ngIf="p.participantImageURL">
                      <img [src]="p.participantImageURL" alt="" />
                    </div>

                    <div class="userpic" *ngIf="!p.participantImageURL">
                      <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                      <span class="shortName" *ngIf="!p.participantName">{{getShortName(p.contactEmail)}}</span>
                    </div>

                    <div class="info">
                      <p *ngIf="p.participantName">{{ p.participantName }} </p>
                      <p *ngIf="!p.participantName">{{p.contactEmail}}</p>
                    </div>

                    <button class="removeContact" mat-icon-button color="basic" (click)="RemoveRelation(p)">
                      <mat-icon>close</mat-icon>
                    </button>

                  </div>

                  <ng-container *ngIf="!p.participantName && !p.roleName &&  !p.contactEmail">
                    <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUser(addAssigne,true,false,'',p,p1)">
                      <mat-icon>person_add</mat-icon>
                    </button>
                    <span class="addEmail" (click)="assignUser(addAssigne,true,false,'',p,p1)">Add email</span>
                  </ng-container>

                </div>
                <div class="Cancel">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <!-- <span>
      <button mat-flat-button color="primary"  [disabled]="!SendButtonDisabled" (click)="ProjectSend(templateRefAccept,signature)">Send</button>
      </span> -->
  </mat-dialog-actions>
</ng-template>
<ng-template #extendProject>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>work</mat-icon></span>
    Extend Project
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div class="panel">

      <div class="alert alert-danger" role="alert">
        Exipred on {{selectedSentItem.expiryDate| date: "MM/dd/yyyy"}}
      </div>

      <mat-form-field appearance="fill">
        <mat-label>Extend project by days :</mat-label>
        <input matInput placeholder="Enter days" max="30" (input)="onChange($event.target.value)" type="number" min="0">
      </mat-form-field>

    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="" (click)="close()">Close</button>
    <button mat-button color="primary" (click)="renewProject()">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #addAssigne>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Participant
    <button mat-icon-button (click)="closeAssignParticipant()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <ng-container>
      <form class="example-form">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search contact or type email</mat-label>
          <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
            (input)="searchUserProject($event.target.value)" id="stateCtrlid">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option (click)="contactSelected(contact)" *ngFor="let contact of contactsList" [value]="contact.name">
              <span class="userlist" style="display: flex;" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="userpic">
                  <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                  <span class="username" *ngIf="contact.imageUrl==''" class="username">
                    {{contact.shortName}}
                  </span>
                </div>
                <div class="info1">
                  <p> {{ contact.name }}</p>
                </div>
              </span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeAssignParticipant()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateParticipants()">Done</button>
  </mat-dialog-actions>
</ng-template>